export interface GetClientDeleteSummaryResponse {
  summary: string;
  items: string[]
};

export interface GetClientDeleteDetailsResponse {
  hasItems: boolean;
  items: string[]
  error?: string
};

export interface ClientDeleteResponse {
  completed: boolean;
  items: string[]
  error?: string
};

export interface DeleteClientActionItem {
  actionName: string;
  actionBy: string;
  actionAtUtc: string | null;
  actionDetails: string[];
};

export interface DeleteClientItemTypeInfo {
  type: DeleteClientItems;
  hasItem: boolean;
  isDeleted: boolean;
  actionItems: DeleteClientActionItem[];
};

export interface DeleteClientInformation {
  clientId: number;
  clientKey: string;
  clientName: string;
  organisationId: string;

  // Requested is when it was initially requested for deletion
  deletionRequestedAtUtc: string | null;
  deletionRequestedBy: string | null;

  // Completed is when the client was deleted from the data store and all items were deleted
  deletionCompletedAtUtc: string | null;
  deletionCompletedBy: string | null;

  items: DeleteClientItemTypeInfo[];
};

export interface DeleteClientInformationResponse {
  information: DeleteClientInformation | null;
  error?: string;
};

export enum DeleteClientItems {
  NewWorldIntegration = 'NewWorldIntegration',
  CCRecBlobStorage = 'CCRecBlobStorage',
  CCRecSQLRecords = 'CCRecSQLRecords',
  ReceiptTrayBlobStorage = 'ReceiptTrayBlobStorage',
  ReceiptTraySQLRecords = 'ReceiptTraySQLRecords',
  BasiqBlobStorage = 'BasiqBlobStorage',
  BasiqSQLRecords = 'BasiqSQLRecords',
  OtherBlobStorage = 'OtherBlobStorage',
  OtherTableStorage = 'OtherTableStorage',
  LegacyBlobStorage = 'LegacyBlobStorage',
  ClientSQLRecords = 'ClientSQLRecords'
}
